import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  copyrightText = '©Copyright 2023, all rights reserved with Dhwani RIS'
  images: any = [
    {
      path: '../../assets/images/media1.svg',
      backgroundColor: 'lightgray',
      class: 'fab fa-facebook',
      hover: 'blue',
      color: 'white',
      radius: 50,
      link: 'https://www.facebook.com/ManyataForMothers',
    },
    {
      path: '../../assets/images/media2.svg',
      backgroundColor: 'white',
      class: 'fab fa-twitter',
      hover: 'blue',
      color: 'lightgray',
      radius: '',
      link: 'https://twitter.com/Manyata4Mothers',
    },
    {
      path: '../../assets/images/media3.svg',
      backgroundColor: 'lightgray',
      class: 'fab fa-linkedin-in',
      hover: 'blue',
      color: 'white',
      radius: 0,
      link: 'https://in.linkedin.com/in/manyata-for-mothers-804b80177',
    },
    {
      path: '../../assets/images/media4.svg',
      backgroundColor: 'white',
      class: 'fab fa-youtube',
      hover: '',
      color: 'lightgray',
      radius: '',
      link: 'https://www.youtube.com/channel/UC347Dzf1l8Ur4AlHD5MvOcQ',
    },
  ];


  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  scrollToTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  goToPrivacyPolicy() {
    // this.router.navigateByUrl('')
  }
}
